import { render, staticRenderFns } from "./SolutionItem.vue?vue&type=template&id=d1ca7bf6&scoped=true&"
import script from "./SolutionItem.vue?vue&type=script&lang=ts&"
export * from "./SolutionItem.vue?vue&type=script&lang=ts&"
import style0 from "./SolutionItem.vue?vue&type=style&index=0&id=d1ca7bf6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ca7bf6",
  null
  
)

export default component.exports